import ProductHeader from "./ProductHeader";
import PageTitleWrapper from "src/components/PageTitleWrapper";
import { Grid, Container, Card } from "@mui/material";
import Footer from "src/components/Footer";

import ProductVariantsContent from "./ProductVariantsContent";

function ApplicationsAttributes() {
  return (
    <>
      <title>Product - Applications</title>
      <PageTitleWrapper>
        <ProductHeader />
      </PageTitleWrapper>
      <Container maxWidth="lg">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}>
          <Grid item xs={12}>
            <Card>
              <ProductVariantsContent />
            </Card>
          </Grid>
        </Grid>
      </Container>
      <Footer />
    </>
  );
}

export default ApplicationsAttributes;
